import { SERVICE_CATEGORIES } from '@/helpers/constants'

export const SERVICES_SELECTION_STORAGE_KEY = 'services-selection'
export const SERVICES_VIEW_STORAGE_KEY = 'services-view'

export const DEFAULT_SERVICES_VIEW = {
  colorfulIcons: true,
  showIcons: true,
}

export const SERVICE_CATEGORY_LIST = SERVICE_CATEGORIES as string[]

// Note: the category is a plain string on the BE; its translation key is derived here
export const SERVICE_CATEGORY_LABEL_KEYS = {
  'Beauty Services': 'beautyServices',
  Gift: 'gift',
  'Group Training': 'groupTraining',
  'Handyman Services': 'handymanServices',
  'Home Services': 'homeServices',
  'Massage Therapy': 'massageTherapy',
  'Moving Services': 'movingServices',
  'Nutrition Services': 'nutritionServices',
  'Personal Training': 'personalTraining',
  'Pet Services': 'petServices',
} as const

export type ServiceCategory = keyof typeof SERVICE_CATEGORY_LABEL_KEYS

// Note: subservices of these categories are timed, so they carry a duration and a quantity
export const TIMED_CATEGORIES = [
  'Personal Training',
  'Group Training',
  'Massage Therapy',
  'Beauty Services',
  'Moving Services',
  'Handyman Services',
  'Pet Services',
  'Home Services',
]

// Note: the BE creates no training type for these categories, so icon and color are optional
export const NO_TRAINING_TYPE_CATEGORIES = ['Nutrition Services', 'Gift']

export const SERVICE_NAME_MAX_LENGTH = 100
export const SERVICE_DESCRIPTION_MAX_LENGTH = 1000
export const SKU_NAME_MAX_LENGTH = 100
export const SKU_DURATION_MAX = 1440
export const SKU_QUANTITY_MAX = 999
export const SKU_COST_MAX = 100000

// Note: wide enough for 10 icon options per row (5.2rem each, 0.8rem gap), so the 14 icons take two rows
export const SERVICE_FORM_WIDTH = '60rem'
